export default __webpack_public_path__ + "static/media/safiya-noble.2f36a77a.jpg";